import { Badge, Group, Paper, Text } from "@mantine/core";
import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";
import type { ExplodeNodeData } from "./types";
import { NodeRole } from "./types";

const ROLE_STYLE = {
    [NodeRole.ROOT]: { bg: "purple.7", fg: "white", border: "#5f3dc4" },
    [NodeRole.GROUP]: { bg: "white", fg: undefined, border: "#5f3dc4" },
};

export const BucketNode = ({ data }: NodeProps<Node<ExplodeNodeData>>) => {
    const style = ROLE_STYLE[data.role];
    const isRoot = data.role === NodeRole.ROOT;
    return (
        <Paper
            withBorder
            p="md"
            radius="md"
            bg={style.bg}
            style={{
                width: 240,
                borderColor: style.border,
                borderWidth: 2,
                cursor: isRoot ? "default" : "pointer",
            }}
        >
            {!isRoot && <Handle type="target" position={Position.Top} />}
            <Group justify="space-between" gap="sm" wrap="nowrap" align="center">
                <Text
                    size="md"
                    fw={700}
                    lineClamp={2}
                    c={style.fg}
                    style={{ flex: 1, minWidth: 0 }}
                >
                    {data.label}
                </Text>
                {data.count !== undefined && (
                    <Badge
                        size="lg"
                        variant={isRoot ? "white" : "filled"}
                        color="purple"
                        style={{ flexShrink: 0 }}
                        styles={{ label: { overflow: "visible" } }}
                    >
                        {data.count.toLocaleString()}
                    </Badge>
                )}
            </Group>
            {isRoot && <Handle type="source" position={Position.Bottom} />}
        </Paper>
    );
};
